<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <div class="line-box">
      <el-form-item label="用户名" prop="username" class="styW">
          <el-input v-model="dataForm.username" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" class="styW"> 
          <el-input v-model="dataForm.password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="realName" class="styW">
          <el-input v-model="dataForm.realName" placeholder="姓名"></el-input>
      </el-form-item>
<!--          <el-form-item label="性别" prop="gender">-->
<!--          <el-input v-model="dataForm.gender"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="邮箱" prop="email" class="styW">
          <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>
        <el-form-item prop="gender" label="性别" size="mini" class="styW">
            <el-radio-group v-model="dataForm.gender">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
            </el-radio-group>
        </el-form-item >
        <el-form-item prop="superUser" label="是否超级用户" size="mini" class="styW">
            <el-radio-group v-model="dataForm.superUser">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
      
      <el-form-item label="手机号" prop="mobile" class="styW">
          <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
<!--          <el-form-item label="部门ID" prop="deptId">-->
<!--          <el-input v-model="dataForm.deptId" placeholder="部门ID"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="是否超级用户" prop="superUser">-->
<!--          <el-input v-model="dataForm.superUser"></el-input>-->
<!--      </el-form-item>-->
       
      <el-form-item label="默认手机验证码" prop="defaultVerification code" class="styW">
          <el-input v-model="dataForm.defaultVerificationCode" placeholder="默认手机验证码"></el-input>
      </el-form-item>
      </div>
    </el-form>
    <template slot="footer" >
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        username: '',
        password: '',
        realName: '',
        gender: '',
        email: '',
        mobile: '',
        deptId: '',
        superUser: '',
        defaultVerificationCode: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // password: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // realName: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // gender: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // email: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // mobile: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // deptId: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        superUser: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        defaultVerificationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/appsysuser/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/appsysuser/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
